import * as React from 'react';
const SvgDashboardArrowStay = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, fill: "none" }, props),
    React.createElement("circle", { cx: 7, cy: 7, r: 7, fill: "#FFA471", transform: "rotate(-90 7 7)" }),
    React.createElement("path", { fill: "#fff", d: "M11.2 7.863V6.137H6.035l2.1-2.129L6.943 2.8 2.8 7l4.143 4.2 1.192-1.208-2.1-2.129H11.2Z" })));
export default SvgDashboardArrowStay;
